import * as storage from "app/data/storage";

export const authRoles = {
  //default roles config
  sa: ["SA", "ADMIN"], // Only Super Admin has access
  admin: ["SA", "ADMIN"],
  editor: ["SA", "EDITOR"],
  guest: ["SA", "GUEST"],
  pesqres: ["SA", "PESQRES"],
  pesq: ["SA", "PESQ"],
  empresa: ["SA", "EMPRESA"],
  pesqemp: ["SA", "PESQEMP"],
  aluposgra: ["SA", "ALUPOSGRA"],
  alupos: ["SA", "ALUPOS"],
  aludout: ["SA", "ALUDOUT"],
  opelce: ["SA", "ADMIN", "OPELCE"],
  admlce: ["SA", "ADMLCE"],
  permitAll: [
    "SA",
    "ADMIN",
    "GUEST",
    "PESQRES",
    "PESQ",
    "EMPRESA",
    "PESQEMP",
    "ALUPOSGRA",
    "ALUPOS",
    "ALUDOUT",
    "OPELCE",
    "ADMLCE",
  ],

  allExceptGuest: [
    "SA",
    "ADMIN",
    "PESQRES",
    "PESQ",
    "EMPRESA",
    "PESQEMP",
    "ALUPOSGRA",
    "ALUPOS",
    "ALUDOUT",
    "OPELCE",
    "ADMLCE",
  ],

  instituton: ["SA", "ADMIN", "ADMLCE"],
  institutinAndOpelce: ["SA", "ADMIN", "ADMLCE", "OPELCE"],
  users: ["SA", "ADMIN", "PESQRES", "EMPRESA", "ADMLCE"],
  userlist: ["SA", "ADMIN", "ADMLCE"],
  finance: ["SA", "ADMIN", "ADMLCE"],
  finance_pesquisadores: ["SA", "ADMIN", "ADMLCE"],
  reportsMenu: [
    "OPELCE",
    "SA",
    "ADMIN",
    "ADMLCE",
    "PESQRES",
    "EMPRESA",
    "PESQEMP",
    "PESQ",
    "ALUPOSGRA",
    "ALUPOS",
    "ALUDOUT",
  ],
  reports: [
    "SA",
    "ADMIN",
    "ADMLCE",
    "PESQRES",
    "EMPRESA",
    "PESQEMP",
    "PESQ",
    "ALUPOSGRA",
    "ALUPOS",
    "ALUDOUT",
  ],

  manageUsers: ["ADMIN", "PESQRES"],
};

export function userRoleCheck(itemRole: string): boolean {
  const userRole = storage.get("role");

  if (itemRole && userRole) if (itemRole.includes(userRole)) return true;

  return false;
}
